// -----------------------------title-----------------------------
class TitleView {
  type = 'TitleView'

  render() {
    throw new Error("Subclasses must implement their own header");
  }
}
// 自定义头部
class CustomTitle extends TitleView {
  custom

  constructor(custom) {
    super()
    this.custom = custom || null
  }

  render() {
    return this.custom
  }
}
// 默认头部
class DefaultTitle extends TitleView {
  headStyle
  title
  closeButton

  constructor(headStyle, title, closeButton) {
    super()
    this.headStyle = headStyle || {}
    this.title = title || ''
    this.closeButton = closeButton || true
  }

  render() {
    const { Modal } = TinperNext

    return <Modal.Header closeButton={this.closeButton} {...this.headStyle}>
      <Modal.Title>{this.title}</Modal.Title>
    </Modal.Header>
  }
}

// -----------------------------content-----------------------------
class ContentView {
  dialog = null
  type = 'ContentView'

  setDialog(dialog) {
    this.dialog = dialog
    return this
  }

  render() {
    throw new Error("Subclasses must implement their own content");
  }
}
// 自定义内容
class CustomContent extends ContentView {
  custom

  constructor(custom) {
    super()
    this.custom = custom || null
  }

  render() {
    return this.custom
  }
}
// 单据内容
class BillContent extends ContentView {
  containerType = 'modal'
  billNo
  query
  params
  onRootStoreCreated
  rootStore

  constructor(billNo, query, params) {
    super()
    this.billNo = billNo || ''
    this.query = query || {}
    this.params = params || {}
  }

  setContainerType(containerType) {
    this.containerType = containerType ?? 'modal'
    return this
  }

  render() {
    const YNFFragment = React.createElement(window.YNFFragment, {
      billNo: this.billNo,
      query: this.query,
      params: this.params,
      closeDialog: this.dialog.closeDialog,
      onRootStoreCreated: this.onRootStoreCreated
    })
    return YNFFragment
  }
}

// -----------------------------footer-----------------------------
class FooterView {
  dialog = null
  type = 'FooterView'

  setDialog(dialog) {
    this.dialog = dialog
    return this
  }

  render() {
    throw new Error("Subclasses must implement their own footer");
  }
}
// 自定义底部
class CustomFooter extends FooterView {
  custom

  constructor(custom) {
    super()
    this.custom = custom || null
  }

  render() {
    return this.custom
  }
}
// 默认底部
class DefaultFooter extends FooterView {
  footerStyle
  buttons

  constructor(footerStyle, buttons) {
    super()
    this.footerStyle = footerStyle || {}
    this.buttons = buttons || []
  }

  addButton(button) {
    this.buttons.push(button)
    return this
  }

  render() {
    if (!this.buttons.length) return <></>

    const { Modal, Button } = TinperNext

    return <Modal.Footer>
      { this.buttons.map(item => <Button
          colors={item.colors}
          style={{ marginLeft: 8 }}
          onClick={() => {
            item.onClick?.(this.dialog.contentView.rootStore)
            item.closeModal && this.dialog.closeDialog?.()
          }}>
        {item.caption}
      </Button>) }
    </Modal.Footer>
  }
}

// -----------------------------窗口-----------------------------
class Dialog {
  showModal = true // 弹窗是否显示
  bodyStyle = {} // modal样式
  zIndex = 1000
  mask = true // 是否显示遮罩层
  titleView = null
  contentView = null
  footerView = null
  closeDialog = null // 关闭事件
  modalProps = {} // 其他弹窗属性，这里面的属性都传到modal组件上

  constructor() {
    this.titleView = new DefaultTitle()
    this.contentView = new CustomContent()
    this.contentView.setDialog(this)
    this.footerView = new DefaultFooter()
    this.footerView.setDialog(this)
  }

  setShowModal(showModal) {
    this.showModal = showModal ?? true
    return this
  }

  setBodyStyle(bodyStyle) {
    this.bodyStyle = bodyStyle ?? {}
    return this
  }

  setZIndex(zIndex) {
    this.zIndex = zIndex ?? 1000
    return this
  }

  setMask(mask) {
    this.mask = mask ?? true
    return this
  }

  setTitleView(titleView) {
    this.titleView = titleView
    return this
  }

  setContentView(contentView) {
    this.contentView = contentView
    this.contentView.setDialog(this)
    return this
  }

  setFooterView(footerView) {
    this.footerView = footerView
    this.footerView.setDialog(this)
    return this
  }

  setCloseDialog(closeDialog) {
    this.closeDialog = closeDialog
    return this
  }

  setModalProps(modalProps) {
    this.modalProps = modalProps
    return this
  }

  getTitleView() {
    return this.titleView
  }

  getContentView() {
    return this.contentView
  }

  getFooterView() {
    return this.footerView
  }
}

// -----------------------------DialogBuilder类-----------------------------
export class DialogBuilder {
  // 默认创建的是自定义弹窗
  static create(custom = null) {
    const dialog = new Dialog()
    const content = DialogBuilder.createCustomContent(custom)
    dialog.setContentView(content)
    return dialog
  }
  // 创建bill类弹窗
  static createBillDialog(billNo, query, params) {
    const dialog = new Dialog()
    const content = DialogBuilder.createBillContent({ billNo, query, params })
    dialog.setContentView(content)
    return dialog
  }

  // 快捷创建默认头部
  static createTitle(headStyle, title, closeButton) {
    return new DefaultTitle(headStyle, title, closeButton)
  }
  // 快捷创建自定义头部
  static createCustomTitle(custom) {
    return new CustomTitle(custom)
  }
  // 快捷创建自定义内容
  static createCustomContent(custom) {
    return new CustomContent(custom)
  }
  // 快捷创建单据内容
  static createBillContent(billNo, query, params) {
    return new BillContent(billNo, query, params)
  }
  // 快捷创建默认底部
  static createFooter(footerStyle, buttons) {
    return new DefaultFooter(footerStyle, buttons)
  }
  // 快捷创建自定义底部
  static createCustomFooter(custom) {
    return new CustomFooter(custom)
  }
  // 快捷创建带确定和取消按钮的底部
  static createOkCancelFooter(onOk = () => {}, onCancel = () => {}) {
    const footer = DialogBuilder.createFooter()
    footer.addButton({
      closeModal: true,
      colors: "secondary",
      caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80029', '取消'),
      onClick: onCancel
    })
    footer.addButton({
      closeModal: true,
      colors: 'primary',
      caption: lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80034', '确定'),
      onClick: onOk
    })
    return footer
  }
}